import httpRequest from "../../../axios/index";
import { ADMIN_AGENTS } from "../../../constants/apiEndPoints";
import { toast } from "react-hot-toast";

const GetAllAgents = async (setLoading, SetAllData, Search = "", page = 1) => {
  try {
    setLoading(true);
    let params = new URLSearchParams();
    if (Search) {
      params.append("search", Search);
    }
    if (page) {
      params.append("page", page);
    }
    let url = `${ADMIN_AGENTS}`;
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    const resp = await httpRequest.get(url);
    if (resp?.status === 200) {
      if (resp?.data?.message === "Success") {
        SetAllData(resp?.data);
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

const CreateAgents = async (setLoading, data = "") => {
  try {
    setLoading(true);
    const resp = await httpRequest.post(`${ADMIN_AGENTS}`, data);
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

const GetPermissions = async () => {
  try {
    const resp = await httpRequest.get(`${ADMIN_AGENTS}/permissions`);
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  }
};

const GetComePermissions = (permissions = []) => {
  const selectedPermissions = permissions
    .map((option) => option.name)
    .join(",");
  return selectedPermissions;
};

const UpdatePermissions = async (setLoading, id, data = "") => {
  try {
    setLoading(true);
    const resp = await httpRequest.patch(`${ADMIN_AGENTS}/${id}`, data);
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

export {
  GetAllAgents,
  CreateAgents,
  GetPermissions,
  GetComePermissions,
  UpdatePermissions,
};
